import React, { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./detailComponents/AdsRegistStep0.css"; // Assuming you have a CSS file for custom styles
import { TwinColumn } from "../../../assets/components/ButtonGroup";

import registIcon1 from "../../../assets/image/login/step0_1.png";
import registIcon2 from "../../../assets/image/login/2.png";
import registIcon3 from "../../../assets/image/login/3.png";
import registIcon4 from "../../../assets/image/login/4.png";

const slides = [
    {
        img: registIcon1,
        title: "버튼 한 번이면 끝!",
        lines: [
            "AI가 알아서 매력적인 \n 이미지를 빠르게 만들어줘요."
        ],
    },
    {
        img: registIcon2,
        title: "반응이 터지는 이미지 찾기!",
        lines: [" AI가 생성된 이미지에 대한 \n SNS 반응을 분석해 줘요."],
    },
    {
        img: registIcon3,
        title: "예약 알림이면 OK!",
        lines: ["매일, 매주, 매월 잊지 않고 \n 꾸준히 마케팅할 수 있게 도와줘요."],
    },
    {
        img: registIcon4,
        title: "내 매장, 더 스마트하게 성장!",
        lines: ["AI가 매장 데이터를 분석해 \n 성장 팁까지 알려줘요."],
    },
];

const AdsRegistStep0 = ({ onNext, setStep1InitialMode }) => {
    const swiperRef = useRef(null);

    // 회원가입 분기
    const handleSignupFlow = () => {
        setStep1InitialMode("signup"); // 굳이 안 해도 기본은 signup이지만 명시해도 OK
        onNext();                      // stepIndex + 1 → Step1
    };

    // 로그인 분기로 바로 가는 버튼
    const handleLoginFlow = () => {
        setStep1InitialMode("login");  // 다음 Step1을 로그인 모드로
        onNext();                      // navigate 안 쓰고 step 이동만
    };

    const handleNext = () => {
        const swiper = swiperRef.current?.swiper;
        if (!swiper) return;
        if (swiper.isEnd) handleSignupFlow?.();
        else swiper.slideNext();
    };

    return (
        <div className="flex flex-col min-h-[100dvh]">
            <div className="flex-1 flex flex-col items-center justify-center pt-[100px]">
                <Swiper
                    ref={swiperRef}
                    modules={[Pagination]}
                    slidesPerView={1}
                    spaceBetween={0}
                    centeredSlides={false}
                    resistanceRatio={0.85}
                    pagination={{
                        el: ".regist-custom-pagination",
                        clickable: true,
                        type: "bullets",
                        dynamicBullets: false,
                    }}
                    className="w-full"
                >
                    {slides.map((s, i) => (
                        <SwiperSlide
                            key={i}
                            className="flex flex-col items-center text-center"
                        >
                            <div className="w-[240px] h-[240px] flex items-center justify-center mx-auto">
                                <img
                                    src={s.img}
                                    alt={`회원가입 안내 ${i + 1}`}
                                    className="max-w-full max-h-full object-contain"
                                />
                            </div>

                            <div className="pt-[44px]">
                                <h2 className="text-t2 text-text-default pb-[12px]">
                                    {s.title}
                                </h2>
                                {s.lines.map((line, li) => (
                                    <h2
                                        key={li}
                                        className="text-b1 text-text-tertiary whitespace-pre-line"
                                    >
                                        {line}
                                    </h2>
                                ))}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* 인디케이터도 중앙 아래에 */}
            <div className="regist-custom-pagination flex justify-center pb-[12px]" />

            {/* 하단 버튼 영역 */}
            <div>
                <TwinColumn
                    topText={"다음"}
                    bottomType={"empty"}
                    bottomText={
                        <>
                            <span>이미 계정이 있나요? </span>
                            <span className="text-text-primary">로그인하기</span>
                        </>
                    }
                    onTop={handleNext}
                    onBottom={handleLoginFlow}
                />
            </div>
        </div>
    );

};


export default AdsRegistStep0;
